import { GlobalLoader } from "@expert/common-ui";
import { GaiaWebsocketProvider } from "@expert/gaia";
import { RootAnalyticsProvider } from "@soluto-private/eventualize-react";
import { useEffect } from "react";

import type { ReusableMainContainerProps } from "../components";

import { Header, PageContainer, ReusableMainContainer, SidebarFeedbackButton, StandaloneTimeline } from "../components";
import { useInitializers } from "../initializers";
import { useExpertAssistStore, useLoggerWithContextStore } from "../state";
import { env } from "../utils/env";
import classes from "./Home.module.css";

function MainContainer(props: Omit<ReusableMainContainerProps, "className">) {
    return <ReusableMainContainer {...props} className={classes.mainContainer} />;
}

export function Home() {
    useInitializers();
    const { loggerWithContext } = useLoggerWithContextStore();
    const { sessionId, token, expertProfile } = useExpertAssistStore();

    useEffect(() => {
        loggerWithContext.info({ module: "Home", domain: window.location.hostname }, "Home page loaded");
        // oxlint-disable-next-line exhaustive-deps
    }, []);

    if (!sessionId) return <GlobalLoader msg="Loading Expert Assist..." />;

    return (
        <RootAnalyticsProvider>
            <GaiaWebsocketProvider
                logger={loggerWithContext}
                identity={expertProfile.id}
                application="expert-workspace" // TODO: update this to expert-assist once supported by gaia
                token={token ?? ""}
                url={env.gaiaWebsocketUrl}
            >
                <PageContainer>
                    <Header />
                    <MainContainer direction="column" justify="flex-end" pb="sm" pt="3xl">
                        <StandaloneTimeline />
                    </MainContainer>
                    <SidebarFeedbackButton />
                </PageContainer>
            </GaiaWebsocketProvider>
        </RootAnalyticsProvider>
    );
}
